const {
  ADD_POMPE_REQUEST,
  ADD_POMPE_SUCCESS,
  ADD_POMPE_FAIL,
  UPDATE_POMPE_REQUEST,
  UPDATE_POMPE_SUCCESS,
  UPDATE_POMPE_FAIL,
  DELETE_POMPE_REQUEST,
  DELETE_POMPE_SUCCESS,
  DELETE_POMPE_FAIL,
} = require("../../actionTypes/Paramaetrage/Pompe");

function addPompe(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_POMPE_REQUEST:
      return { loading: true, data: {} };
    case ADD_POMPE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_POMPE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updatePompe(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_POMPE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_POMPE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_POMPE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deletePompe(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_POMPE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_POMPE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_POMPE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export { addPompe, updatePompe, deletePompe };
